import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';
import {
  updateCustomerCenterConfigurationSuccess,
  updateCustomerCenterConfigurationFailure,
  fetchCustomerCenterConfigurationSuccess,
  fetchCustomerCenterConfigurationFailure,
} from './customer-center-configuration-actions';

export function* doFetchCustomerCenterConfiguration(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'configuration/scope',
      options: {
        errorMessage: 'Could not fetch configuration scope',
        retryAction: action,
      },
    });
    yield put(fetchCustomerCenterConfigurationSuccess(results));
  } catch (err) {
    yield put(fetchCustomerCenterConfigurationFailure(err));
  }
}

export function* doUpdateCustomerCenterConfiguration(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'configuration/scope',
      options: {
        method: 'POST',
        body: JSON.stringify(action.payload),
        errorMessage: 'Could not update configuration scope',
        retryAction: action,
      },
    });
    yield put(updateCustomerCenterConfigurationSuccess(results));
  } catch (err) {
    yield put(updateCustomerCenterConfigurationFailure(err));
  }
}

function* watchFetchCustomerCenterConfiguration() {
  yield takeLatest(
    actionTypes.FETCH_CUSTOMER_CENTER_CONFIGURATION_REQUEST,
    doFetchCustomerCenterConfiguration,
  );
}

function* watchUpdateCustomerCenterConfiguration() {
  yield takeLatest(
    actionTypes.UPDATE_CUSTOMER_CENTER_CONFIGURATION_REQUEST,
    doUpdateCustomerCenterConfiguration,
  );
}

export default [
  fork(watchFetchCustomerCenterConfiguration),
  fork(watchUpdateCustomerCenterConfiguration),
];
